var exports = {
  "w": "EventText__UnZD96",
  "v": "timestamp__fld0Sw",
};

module.exports = exports;
